<template>
    <main class="container">
        <section>
            <h2>玩法规则</h2>
            <ul>
                <li>每轮活动，平台会预先存入10000元作为金库池活动奖金；</li>
                <li>每次玩家兑换金卡，金额的30%直接存入金库奖池，70%用来给金卡持有者分红，每五分钟分红一次；</li>
                <li>用钥匙兑换金卡，永久为一把钥匙一张金卡；</li>
                <li>单个金库结束时间为4小时，任意用户兑换金卡，将增加结束时间0.5秒钟；</li>
                <li>金库倒计时结束后，最后兑换金卡的用户获得金库池全部奖金。</li>
            </ul>
        </section>
        <section>
            <h2>注意事项</h2>
            <ol>
                <li>金卡获得分红收益每5分钟结算一次；</li>
                <li>金卡不得退还，不得转赠他人，用金币购买金卡视为立即使用；</li>
                <li>活动期间，如果用户出现违规行为（如通过机器、外挂等恶意获取金卡的），平台有权撤销违规用户的收益，并保留法律追究的权利；</li>
                <li>平台保留对该活动的最终解释权。</li>
            </ol>
        </section>
    </main>
</template>
<script>
export default {
    
}
</script>
<style lang="less" scoped>
main {
	padding: 0.25rem 0.16rem;
}

h2 {
	font-size: 0.16rem;
	line-height: 0.16rem;
	color: #5c3f0a;
	padding: 0.1rem 0;
  font-weight:bold;
}

ul li {
	margin-bottom: 0.15rem;
	font-size: 0.15rem;
	color: #4a4a4a;
	list-style: none;
	line-height: 0.22rem;
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	flex-direction: row;
}

ul li::before {
	content: "";
	margin-top: 0.06rem;
	margin-right: 0.08rem;
	padding: 0.04rem;
	border-radius: 50%;
	background: #d6ba8a;
}

ol {
	counter-reset: li;
	padding-left: 0.03rem;
}

ol li {
	margin-bottom: 0.15rem;
	font-size: 0.15rem;
	color: #4a4a4a;
	list-style: none;
	line-height: 0.22rem;
}

ol li::before {
	counter-increment: li;
	content: counter(li) '、';
}
</style>